import React from "react";
import { useNavigate } from "react-router-dom";
import { createPage } from "adminApi/PageApi/Page";
import { validateForm } from "utils/validation";
import Spinner from "Common/Globle/Spinner";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import fields from "../json/PagesFields.json";
import PageForm from "./Components/PageForm";

// Validation rules for Pages (must match validateForm array-of-objects format)
const PageRules = {
    name: [
        { rule: "required", label: "Title" },
        { rule: "minLength", value: 2, label: "Title" },
    ],
    slug: [
        { rule: "required", label: "Slug" },
    ],
    content: [
        { rule: "required", label: "Content" },
    ],
};

const AddPage = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    const initialValues = formdata.reduce((acc, field) => ({
        ...acc,
        [field.name]: field.type === "switch" ? "1" : "",
    }), {});

    const { values, errors, handleChange, setErrors } = useFormChange(initialValues, PageRules);

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await createPage(formValues);
        },
        (vals) => {
            const err = validateForm(vals, PageRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Page created successfully"
    );

    return (
        <>
            {loadingSubmit && <Spinner isSpinner={true} />}
            <PageForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Add New Page"
                submitLabel="Save Page"
            />
        </>
    );
};

export default AddPage;
